"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const RatingWrap = styled_components_1.default.div({
    display: 'flex',
    flexShrink: 0,
});
const RatingItem = styled_components_1.default.span({
    display: 'flex',
});
const Rating = props => {
    const { rating, ratingContent = null, remainRatingContent = null, halfWayRatingContent = null, testId, className, } = props;
    if (rating === 0)
        return null;
    const maxRating = props.maxRating || rating;
    const halfWayRating = rating % 1;
    const totalRating = rating - halfWayRating;
    const remainRating = maxRating - Math.ceil(rating);
    return (react_1.default.createElement(RatingWrap, { className: className, "data-id": testId },
        Array.from({ length: totalRating }, (_, i) => (react_1.default.createElement(RatingItem, { type: "rating", key: i, className: "rating" }, ratingContent))),
        halfWayRating !== 0 && (react_1.default.createElement(RatingItem, { type: "halfWayRating", className: "halfWayRating" }, halfWayRatingContent)),
        Array.from({ length: remainRating }, (_, i) => (react_1.default.createElement(RatingItem, { type: "remainRating", className: "remainRating", key: i }, remainRatingContent)))));
};
exports.default = Rating;
//# sourceMappingURL=Rating.js.map